'use client';

import { useLocalStorage } from '@shared/hooks';
import { useIsMobile } from '@shared/utils';
import { type ComponentProps, useSyncExternalStore } from 'react';
import { EducationalModal } from './components/Modal/EducationalModal';
import { EducationalSheet } from './components/Sheet/EducationalSheet';

const TUTORIAL_STORAGE_KEY = 'educational-tutorial-completed';
const DEFAULT_TUTORIAL_VALUE = false;

const isBoolean = (value: unknown): value is boolean => typeof value === 'boolean';

const subscribe = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

type EducationalTutorialProps = ComponentProps<'div'>;

function EducationalTutorial(props: EducationalTutorialProps) {
  const mounted = useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
  const isMobile = useIsMobile({ breakpoint: 'md' });
  const [completed, setCompleted] = useLocalStorage<boolean>(TUTORIAL_STORAGE_KEY, DEFAULT_TUTORIAL_VALUE, isBoolean);

  if (!mounted || completed) {
    return null;
  }

  const handleTutorialComplete = () => setCompleted(true);

  return isMobile ? <EducationalSheet onComplete={handleTutorialComplete} {...props} /> : <EducationalModal onComplete={handleTutorialComplete} {...props} />;
}

export { EducationalTutorial };
